import { MarketType } from '../models/request-and-responses/rest-api/enums/marketType';
import { TypeContract } from '../models/request-and-responses/rest-api/enums/typeContract.enum';

interface IMarketTypeSelectItem {
    value: MarketType;
    label: string;
}

export class MarketTypes {
    private static readonly [MarketType.Free]: IMarketTypeSelectItem = {
        value: MarketType.Free,
        label: 'Libero'
    };
    private static readonly [MarketType.Guaranteed]: IMarketTypeSelectItem = {
        value: MarketType.Guaranteed,
        label: 'Maggior tutela'
    };
    private static readonly [MarketType.Fui]: IMarketTypeSelectItem = {
        value: MarketType.Fui,
        label: 'Servizio di ultima istanza'
    };
    private static readonly [MarketType.Safeguard]: IMarketTypeSelectItem = {
        value: MarketType.Safeguard,
        label: 'Salvaguardia'
    };
    private static readonly [MarketType.TutelaGraduale]: IMarketTypeSelectItem = {
        value: MarketType.TutelaGraduale,
        label: 'Tutela graduale'
    };

    static Pod(typeContract: TypeContract): IMarketTypeSelectItem[] {
        switch (typeContract) {
            case TypeContract.Business:
                return [
                    MarketTypes[MarketType.Free],
                    MarketTypes[MarketType.Guaranteed],
                    MarketTypes[MarketType.Safeguard],
                    MarketTypes[MarketType.TutelaGraduale]
                ];
            case TypeContract.Private:
                return [
                    MarketTypes[MarketType.Free],
                    MarketTypes[MarketType.Guaranteed]
                ];
            default:
                if (typeContract != null) {
                    console.error(`'${typeContract}' is not a valid value for contractType`);
                }
                return [];
        }
    }

    static Pdr(typeContract: TypeContract): IMarketTypeSelectItem[] {
        switch (typeContract) {
            case TypeContract.Business:
            case TypeContract.Private:
                return [
                    MarketTypes[MarketType.Free],
                    MarketTypes[MarketType.Guaranteed],
                    MarketTypes[MarketType.Fui]
                ];
            default:
                if (typeContract != null) {
                    console.error(`'${typeContract}' is not a valid value for contractType`);
                }
                return [];
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/marketTypes.ts